import template from './usersTemplates.html';
import UsersTemplatesCtrl from './usersTemplatesCtrl';

export default {
  template,
  controller: UsersTemplatesCtrl,
  controllerAs: 'vm',
};
